const OrderPaymentDisplayType = {
  PAID: 1,
  NOT_YET_INVOICED: 2,
  PAST_DUE: 3,
  DUE: 4,
  CANCELLED: 5,
  PART_PAID: 6,
  REFUNDED: 7,
  CLOSED: 8,
  OPEN: 10,
};

export default OrderPaymentDisplayType;
